export class Paginator {
  pageSize: number = 50;
  pageNumber: number = 1;
  sortBy: string = '';
  sortOrder: string = '';
  searchTerm: string = '';
}
